module.exports = __webpack_public_path__ + "img/logo-kate-spade@2x.dfd16b5f.png";